<template>
    <div>
        <div v-if="isFreePlan||isTrialPlan">
            <v-btn :class="isExpiredAccount?'orange':'white'" outline small title="Click to view plan options">
                <span :class="isExpiredAccount?'orange--text':'white--text'">{{ accountName }}</span>
            </v-btn>
        </div>
        <div v-if="isPaymentOverdue" @click="dialogOkOnly=true">
            <v-chip v-if="isMobile" small class="warning" label>
                <span class="caption white--text">Payment Overdue</span>
            </v-chip>
            <v-btn v-else class="warning" small>
                Payment Overdue
            </v-btn>
        </div>
        <v-dialog v-model="dialogOkOnly" persistent width="600">
            <ok-only :msg="dialogOkOnlyMsg" :dialogOkOnly.sync="dialogOkOnly" @ok="handleOkOnly"></ok-only>
        </v-dialog>
    </div>
</template>
<script>
import companyAccount from '@/common/companyAccountTypes'
export default {
    data() {
        return {
            dialogUpgrade: false,
            dialogOkOnly: false,
            dialogOkOnlyMsg: `Your account has a past due balance. Please settle your payment to continue using SweldoNow. Unpaid accounts may be temporarily suspended.`
        }
    },
    components: {
        'ok-only': () => import('@/components/BasicPopups/OkOnly')
    },
    methods: {
        handleOkOnly() {
            this.$router.push('/company/billing')
        }
    },
    computed: {
        accountName() {
            return companyAccount.planName()
        },
        isFreePlan() {
            return companyAccount.isFreePlan()
        },
        isTrialPlan() {
            return companyAccount.isTrialPlan()
        },
        isExpiredAccount() {
            return companyAccount.isExpiredAccount()
        },
        isPaymentOverdue() {
            return companyAccount.isPaymentOverdue()
        },
    },
    created() {}
}
</script>